import React from "react";

function FeeChargeIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			fill="none"
			viewBox="0 0 40 40"
		>
			<path
				stroke="maroon"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M20 33.664c7.546 0 13.664-6.118 13.664-13.664 0-7.546-6.118-13.664-13.664-13.664-7.546 0-13.664 6.117-13.664 13.664 0 7.546 6.117 13.664 13.664 13.664z"
			/>
			<path
				fill="#4D3951"
				d="M21.876 16.727l-.016.322-1.768.418.016-.322 1.768-.418zm-.297 2.284l-1.286-.94-.058-.236.465-.11a.755.755 0 00.318-.145.485.485 0 00.16-.509.627.627 0 00-.13-.269.446.446 0 00-.243-.145.77.77 0 00-.367.012l-.503.119.018-.322.414-.098c.22-.052.411-.062.57-.028.161.031.292.102.393.213.101.11.173.255.216.435.036.155.04.302.009.439a.645.645 0 01-.224.357c-.118.101-.291.18-.52.233l1.195.869.006.022-.433.103zm.137-2.962l-.017.322-1.425.337.017-.322 1.425-.337z"
			/>
			<path
				fill="#fff"
				stroke="#4D3951"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.672"
				d="M34.577 21.321L31.807 9.6 5.835 15.74l.846 3.583-3.483.823L5.97 31.867l25.973-6.138-.848-3.583 3.482-.825z"
			/>
			<path
				fill="#4D3951"
				d="M17.563 27.124a4.762 4.762 0 100-9.524 4.762 4.762 0 000 9.524z"
			/>
			<path
				fill="#fff"
				d="M17.437 20.089l-.017.321-1.768.418.017-.321 1.768-.418zm-.297 2.283l-1.287-.94-.057-.235.464-.11a.755.755 0 00.318-.146.484.484 0 00.162-.508.628.628 0 00-.13-.27.447.447 0 00-.244-.145.772.772 0 00-.367.012l-.504.12.019-.323.413-.098c.221-.052.412-.061.571-.028.16.032.291.103.392.213.102.11.174.255.216.436a.97.97 0 01.01.438.645.645 0 01-.224.357c-.118.102-.292.18-.52.234l1.195.868.005.023-.432.102zm.136-2.962l-.016.322-1.425.337.016-.322 1.425-.337z"
			/>
			<path
				stroke="#4D3951"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.784"
				d="M6.543 19.249l22.714-5.087 1.884 7.73"
			/>
		</svg>
	);
}

export default FeeChargeIcon;
